import React, { Component } from "react";
import { Fetch } from "../../utils/fetch";
import Navbar from "../../components/newNavBar";
import {
  Table,
  Select,
  DatePicker,
  Modal,
  message,
  ConfigProvider,
  Button,
  Input,
} from "antd";
import Loader from "../../utils/loader";
import less from "./reimbursement.module.scss";
import cx from "classnames";
import moment from "moment";
import mixpanel from "mixpanel-browser";
import { mixPanelToken, isStage, businessModelType } from "../../config";
import jwt from "../../utils/jwt";

const { Option } = Select;
const { RangePicker } = DatePicker;

const columns = [
  {
    title: "BUS RC",
    dataIndex: "rc",
  },
  {
    title: "Date Range",
    dataIndex: "range",
  },
  {
    title: "Amount Submitted",
    dataIndex: "amountSubmitted",
  },
  {
    title: "Amount Approved",
    dataIndex: "amountApproved",
  },
  {
    title: "View File",
    dataIndex: "view",
    render: ({ showMoreDetails, _id, url }) => {
      if (url) {
        return (
          <div>
            <Button onClick={() => showMoreDetails(_id, url)}>View</Button>
          </div>
        );
      } else {
        return null;
      }
    },
  },
  {
    title: "Status",
    dataIndex: "status",
  },
  {
    title: "Submitted On",
    dataIndex: "submittedOn",
  },
  {
    title: "Approved On",
    dataIndex: "approvedOn",
  },
];

class inspectionData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: 10,
      loading: true,
      tableLoader: false,
      showReimbursementModal: false,
      showAttachments: false,
      busRcsOptions: [],
      reimbursementsTableData: [],
    };
    this.fileInputRef = React.createRef();
  }

  async componentDidMount() {
    try {
      const regex =
        /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      const isMobile = regex.test(navigator.userAgent);
      const stateObj = { loading: false, isMobile };
      const busRcsOptions = await this.fetchRc();
      stateObj.reimbursementsTableData = await this.fetchReimbursements();
      stateObj.busRcsOptions = busRcsOptions;

      const token = localStorage.getItem("idToken");
      const decodedToken = jwt.decode(token);
      let userType = decodedToken.userType || "OPERATOR";
      if (sessionStorage.getItem("userType")) {
        userType = sessionStorage.getItem("userType");
      } else if (decodedToken && decodedToken.isElectricUser) {
        userType = "ELECTRIC";
      }
      stateObj.mobileNo = decodedToken.mobileNo;
      stateObj.userType = userType;

      this.setState(stateObj);
    } catch (err) {
      console.log(err);
    }
  }

  fetchRc = async () => {
    const url = `/user/rc`;
    const options = {
      method: "get",
    };
    const response = await Fetch(url, options);
    if (Array.isArray(response) && response.length > 0) {
      let busRcsOptions = [];
      response.forEach((data) => {
        let selectOpt = {
          rc: data.rc,
        };
        busRcsOptions.push(selectOpt);
      });
      return busRcsOptions;
    } else {
      message.error("something went wrong");
      return [];
    }
  };

  fetchReimbursements = async () => {
    const url = `/user/reimbursements`;
    const options = {
      method: "get",
    };
    const response = await Fetch(url, options);
    if (Array.isArray(response) && response.length > 0) {
      const formatData = this.formatData(response);
      return formatData;
    } else {
      return [];
    }
  };

  formatData = (response) => {
    const data = response.map((data) => {
      return {
        _id: data._id,
        rc: data.rc,
        range: `${moment(data.startDate).format("DD/MM/YY")} -
          ${moment(data.endDate).format("DD/MM/YY")}`,
        amountSubmitted: data.amount,
        amountApproved:
          data.financeStatus === "REJECTED"
            ? 0
            : data.financeStatus === "APPROVED"
            ? data.financeApprovedAmount
            : "NA",
        status: data.financeStatus,
        approvedOn: data.approvedOnDate
          ? moment(data.approvedOnDate).format("DD/MM/YY")
          : "NA",
        submittedOn: moment(data.createdOn).format("DD/MM/YY"),
        view: {
          showMoreDetails: this.showAttachment,
          _id: data._id,
          url: data.fileUrl,
        },
      };
    });
    return data;
  };

  showAttachment = (_id, fileUrl) => {
    this.setState({
      showAttachments: true,
      selectedAttachmentUrl: "https://d1flzashw70bti.cloudfront.net/" + fileUrl,
    });
  };

  handleChange = (key, value) => {
    this.setState({ [key]: value });
  };

  directSearh = async (value) => {
    this.setState({ tableLoader: true });
    const stateObj = { tableLoader: false };

    const url = `/user/reimbursements`;
    const body = {
      rc: value,
    };
    const options = {
      method: "post",
      data: body,
    };
    const response = await Fetch(url, options);
    if (Array.isArray(response) && response.length > 0) {
      stateObj.reimbursementsTableData = this.formatData(response);
      this.setState(stateObj);
      return;
    } else {
      stateObj.reimbursementsTableData = [];
      this.setState(stateObj);
      return;
    }
  };

  addReimbursement = () => {
    const { mobileNo, userType } = this.state;
    const business_model_type = businessModelType.find(
      (opt) => opt.value === userType
    )?.label;
    mixpanel.init(mixPanelToken, { debug: isStage });
    mixpanel.track("Add Reimbursement Clicked", {
      view_from: "Reimbursement Page",
      type: userType,
      mobile_number: mobileNo,
      business_model_type,
    });

    if (this.fileInputRef.current) {
      this.fileInputRef.current.value = "";
    }
    this.setState({
      showReimbursementModal: true,
      rc: undefined,
      selectedFile: undefined,
      startTime: undefined,
      endTime: undefined,
      amount: undefined,
    });
  };

  onTimeRangeSelect = (value, dateString) => {
    const [startTime, endTime] = value;

    this.setState({ startTime, endTime, dateString });
  };

  onFileChange = (event) => {
    this.setState({ selectedFile: event.target.files[0] });
  };

  sendReimbursement = async () => {
    try {
      this.setState({ tableLoader: true });
      let { rc, selectedFile, dateString, amount } = this.state;
      const formData = new FormData();

      if (!rc || !dateString || !amount || !selectedFile) {
        message.error("All Fields are mandatory");
        this.setState({ tableLoader: false });
        return;
      }
      const [startTime, endTime] = dateString;
      const fromDate = moment(startTime, "DD-MM-YYYY").valueOf();
      const toDate = moment(endTime, "DD-MM-YYYY").valueOf();

      formData.append("supplyStatus", "PENDING");
      formData.append("financeStatus", "PENDING");
      formData.append("rc", rc);
      formData.append("amount", amount);
      formData.append("myFile", selectedFile);
      formData.append("startDate", fromDate);
      formData.append("endDate", toDate);

      const url = `/user/addReimbursement`;

      const options = {
        method: "post",
        data: formData,
        headers: { "content-type": "multipart/form-data" },
      };

      let response = await Fetch(url, options);

      const { mobileNo, userType } = this.state;
      mixpanel.init(mixPanelToken, { debug: isStage });
      const business_model_type = businessModelType.find(
        (opt) => opt.value === userType
      )?.label;
      mixpanel.track("Create Trip Clicked", {
        view_from: "Reimbursement Page",
        type: userType,
        mobile_number: mobileNo,
        bus_rc: rc,
        start_date: fromDate,
        end_date: toDate,
        amount,
        business_model_type,
      });

      if (Array.isArray(response)) {
        const formatData = this.formatData(response);
        message.success("Reimbursement is Added");

        this.setState((prevState) => ({
          reimbursementsTableData: [
            ...prevState.reimbursementsTableData,
            formatData[0],
          ],
          tableLoader: false,
          showReimbursementModal: false,
        }));
      }
    } catch (err) {
      console.log(err);
      this.setState({
        tableLoader: false,
        showReimbursementModal: false,
      });
      message.error("Reimbursement is Not Added");
      message.error(err);
    }
  };

  renderAttachmentView() {
    const { selectedAttachmentUrl } = this.state;

    if (!selectedAttachmentUrl) {
      return <p>No attachment selected</p>;
    }
    const extension = selectedAttachmentUrl.split(".").pop().toLowerCase();

    if (["jpg", "jpeg", "png", "webp"].includes(extension)) {
      return (
        <img
          src={selectedAttachmentUrl}
          alt="Attachment"
          style={{ maxWidth: "100%", maxHeight: "70vh", objectFit: "contain" }}
        />
      );
    }

    if (extension === "pdf") {
      return (
        <iframe
          src={selectedAttachmentUrl}
          title="PDF Viewer"
          width="100%"
          height="600px"
          style={{ border: "none" }}
        ></iframe>
      );
    }

    if (extension === "xlsx") {
      return (
        <iframe
          src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
            selectedAttachmentUrl
          )}`}
          style={{ width: "100%", height: "80vh" }}
          title="Excel Viewer"
        />
      );
    }
    if (extension === "csv") {
      return (
        <iframe
          src={selectedAttachmentUrl}
          style={{ width: "10%", height: "2vh" }}
        />
      );
    }

    return <p>Unsupported file type</p>;
  }

  render() {
    const {
      loading,
      startTime,
      endTime,
      isMobile,
      rc,
      searchRc,
      reimbursementsTableData,
      tableLoader,
      busRcsOptions,
      showReimbursementModal,
      active,
      showAttachments,
      amount,
    } = this.state;

    if (loading) {
      return (
        <div className="loader">
          <Loader />
        </div>
      );
    } else {
      return (
        <div>
          <Navbar selectedKey={active} isMobile={isMobile} />
          <div className="container">
            <div className={cx("DealsHeader", less.amenitiesRow)}>
              <span className="dealSpan">Reimbursements</span>
            </div>
            <div className={less.searchHeader}>
              <div>
                <Select
                  allowClear
                  placeholder="Bus Rc"
                  showSearch
                  style={{ width: 320 }}
                  value={searchRc}
                  onChange={(value) => this.directSearh(value)}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {busRcsOptions.map((s) => (
                    <Option value={s.rc} key={s._id}>
                      {s.rc}
                    </Option>
                  ))}
                </Select>
              </div>
              <div onClick={() => this.addReimbursement()}>
                <span>+ Add Reimbursement</span>
              </div>
            </div>
            <ConfigProvider
              theme={{
                token: {
                  colorPrimary: "#7b2bff",
                },
              }}
            >
              <Table
                loading={tableLoader}
                columns={columns}
                bordered={true}
                scroll={{ x: "max-content", y: isMobile ? "70vh" : null }}
                dataSource={reimbursementsTableData}
                pagination={false}
              />
            </ConfigProvider>
            <Modal
              title="Add Reimbursement"
              open={showReimbursementModal}
              onCancel={() => this.setState({ showReimbursementModal: false })}
              footer={null}
            >
              <div className={less.modalContainer}>
                <div>
                  <span> Bus RC *</span>
                  <Select
                    allowClear
                    placeholder="Enter Bus Rc"
                    showSearch
                    style={{ width: 320, height: 40 }}
                    value={rc}
                    onChange={(value) => this.setState({ rc: value })}
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {busRcsOptions.map((s) => (
                      <Option value={s.rc} key={s._id}>
                        {s.rc}
                      </Option>
                    ))}
                  </Select>
                </div>
                <div>
                  <span> Date Select *</span>
                  <RangePicker
                    style={{ width: 320, height: 40 }}
                    value={[startTime, endTime]}
                    format="DD-MM-YYYY"
                    onChange={this.onTimeRangeSelect}
                  />
                </div>
                <div>
                  <span>Amount *</span>
                  <Input
                    style={{ width: 320, height: 40 }}
                    name="phoneNumber"
                    value={amount}
                    onChange={(e) => {
                      const re = /^[0-9\b]+$/;
                      if (e.target.value === "" || re.test(e.target.value)) {
                        this.handleChange("amount", e.target.value);
                      }
                    }}
                  />
                </div>
                <div>
                  <span>File Upload *</span>
                  <input
                    type="file"
                    ref={this.fileInputRef}
                    onChange={this.onFileChange}
                  />
                </div>
              </div>
              <div className={less.modalBtn}>
                <div
                  className={less.cancel}
                  onClick={() =>
                    this.setState({ showReimbursementModal: false })
                  }
                >
                  <span>Cancel</span>
                </div>
                <div
                  className={less.accept}
                  onClick={() => this.sendReimbursement()}
                >
                  <span>Create Trip</span>
                </div>
              </div>
            </Modal>
            {showAttachments ? (
              <Modal
                title="Proof"
                open={showAttachments}
                footer={null}
                width={"80%"}
                onCancel={() => this.setState({ showAttachments: false })}
              >
                <div style={{ textAlign: "center" }}>
                  {this.renderAttachmentView()}
                </div>
              </Modal>
            ) : null}
          </div>
        </div>
      );
    }
  }
}

export default inspectionData;
